import React, { useEffect, useRef } from 'react';
import './contact.css';
import Image from '../../assets/Contact.png';
import emailjs from 'emailjs-com';
import {BsCheckCircleFill} from 'react-icons/bs'
import Aos from 'aos';
import 'aos/dist/aos.css';


function Contact() {

  //Animation
  useEffect(() => {
    Aos.init({
        duration: 2000,
        once: false,
    });
  },[]);

  const form = useRef();

  //Send Email Function
  const sendEmail = (e) => {
    e.preventDefault();
    
    emailjs.sendForm('service_rzomcn8', 'template_9a4px1m', form.current, 'gTtz0-0Yn_07mZhC9')
    e.target.reset();

    const hiddenMessage = document.querySelector('.form__details');
    const showMessage = document.querySelector('.message__success');

    hiddenMessage.classList.add('hidden');
    showMessage.classList.remove('hidden');
  };

  return (
    <section id='contact' className='contact container'>
        <div className='contact__container'>
            <div data-aos="zoom-in" className='container__heading'>
                <h4>Contact</h4>
                <h1>Contact with me</h1>
            </div>

            <div className='contact__body'>
                <div data-aos="fade-right" className='body__left'>
                    <div className='box box_shodow'>
                        <div className='img'>
                            <img src={Image} alt='' />
                        </div>
                        <div className='details'>
                            <h1>Luis Meléndez Rodriguez</h1>
                            <p>React js and Vue js Frontend Developer</p>
                            <div className='content__text'>
                                <p>I am available for freelance work or join to your company, 
                                I have more than 2 years of experience in Frontend development, 
                                using the React js library.</p>
                            </div> <br />
                            <p>Email: luismelendez0894@gmail.com</p>
                        </div>
                    </div>
                </div>

                <div data-aos="fade-right" className='body__right'>
                    <h3>SEND ME A MESSAGE</h3>
                    <form ref={form} onSubmit={sendEmail} className='form__details'>
                        <input 
                            type='text'
                            name='name'
                            placeholder='Your full name'
                            required
                        />

                        <input 
                            type='email'
                            name='email'
                            placeholder='Your Email'
                            required
                        />

                        <textarea
                            id=''
                            name='message'
                            placeholder='Your Message'
                            required
                        ></textarea>

                        <button type='submit' className='btn_send'>Send Message</button>
                    </form>
                    <div className='message__success hidden'>
                        <BsCheckCircleFill />
                        <p>Your message was sent successfully</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Contact